// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#app-settings-content p[data-v-cc75802a]{margin-top:20px;margin-bottom:20px;color:var(--color-text-light)}`, "",{"version":3,"sources":["webpack://./src/components/navigation/AppNavigation.vue"],"names":[],"mappings":"AAEC,yCACC,eAAA,CACA,kBAAA,CACA,6BAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
